import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { UrlConstants } from 'src/app/models/urlConstants';
import { Account, ClientData } from '../components/profile/user-profile-details/client-data';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  constructor(private http: HttpClient, private translate: TranslateService) {}

  fetchBanks(): Observable<any> {
    return this.http.get(`${UrlConstants.backofficeUrl}/api/Settings/GetBanks`);
  }
  fetchBanksDetails(): Observable<any> {
    return this.http.get(`${UrlConstants.backofficeUrl}/api/Settings/GetActiveBanksInsights`);
  }
  fetchCurrencies(): Observable<any> {
    return this.http.get(`${UrlConstants.backofficeUrl}/api/Settings/GetCurrencies`);
  }

  fetchClientAccounts(relationCode: string): Observable<Account[]> {
    return this.http.get<Account[]>(`${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${relationCode}`);
  }

  fetchBOAllSymbols(): Observable<any> {
    return this.http.get(`${UrlConstants.backofficeUrl}/api/Settings/GetSymbols`);
  }

  fetchAllCustod(): Observable<any> {
    return this.http.get(`${UrlConstants.backofficeUrl}/api/Settings/GetCustodians`);
  }

  fetchUserPortfolio(relationCode: string): Observable<ClientData> {
    return this.http.get<ClientData>(`${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${relationCode}`);
  }
  fetchActiveBanks(): Observable<any> {
    return this.http.get(`${UrlConstants.backofficeUrl}/api/Settings/GetActiveBanksInsights`);
  }
  fetchActiveCurrencies(): Observable<any> {
    return this.http.get(`${UrlConstants.backofficeUrl}/api/Settings/GetActiveCurrencies`);
  }
}